import { render, staticRenderFns } from "./theater-comedy.vue?vue&type=template&id=441d3f36"
import script from "./theater-comedy.vue?vue&type=script&lang=js"
export * from "./theater-comedy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports